import SktBridge from '@/services/bridges/skt';

interface IBridge {
  [key: string]: any;
}

const Bridges: IBridge = {
  skt: SktBridge,
};

export default Bridges;
